import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.714 12.228V9.87a2.52 2.52 0 0 0-1.571-2.412V6.437a2.29 2.29 0 0 0-.786-1.72V2.57a.786.786 0 0 0 0-1.571H9.643a.786.786 0 1 0 0 1.571v2.145a2.29 2.29 0 0 0-.786 1.721v.982a2.52 2.52 0 0 0-1.571 2.412v2.358c-.003.474.088.944.267 1.382l.322.786-.322.786a3.6 3.6 0 0 0-.267 1.343v4.11A2.286 2.286 0 0 0 9.415 23h5.17a2.286 2.286 0 0 0 2.13-2.404v-4.11a3.6 3.6 0 0 0-.268-1.343l-.322-.786.322-.786c.174-.426.265-.882.267-1.343m-6.285-5.79a.723.723 0 0 1 .722-.724h1.697a.723.723 0 0 1 .723.723v.849H10.43zm2.357-3.867v1.572h-1.572V2.57zm2.357 9.657c.007.27-.044.537-.15.786l-.447 1.076a.79.79 0 0 0 0 .597l.447 1.077c.105.248.156.516.15.785v4.11c0 .495-.299.832-.558.832h-5.17c-.26 0-.558-.337-.558-.832v-4.173c-.006-.27.044-.537.15-.785l.447-1.077a.79.79 0 0 0 0-.597l-.448-1.076a1.9 1.9 0 0 1-.149-.786V9.808c0-.527.314-.974.684-.974h4.918c.37 0 .684.447.684.974z"
    }, null, -1)
  ]))]))
}
export default { render: render }